import BaseForm from '../base';
import { LatLongColumnsComponent, TwoColumnsComponent } from '../components';
export class LprForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            new TwoColumnsComponent({ key: 'localNetwork' }, {
                label: 'Local IP',
                key: 'ip',
                type: 'textfield',
            }, {
                label: 'LPR Port',
                key: 'lprPort',
                type: 'number',
            }),
            new TwoColumnsComponent({ key: 'credentials' }, {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            }, {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            }),
        ];
    }
}
